import React from "react";
import { Row, Card } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ToggleButton from 'react-toggle-button';
import _ from "lodash";

import { getCurrentCognitoUser, changeUserAttribute } from "../../actions/auth";
import { getUserInfo } from "../../actions/settings";
import HistoryCard from "../../components/dashboard/HistoryCard";
import SettingsItem from "../../components/settings/SettingsItem";
import SettingsMultiSelector from "../../components/settings/SettingsMultiSelector";
import AvatarUploader from "../../components/settings/AvatarUploader";
import ChangePasswordForm from "../../components/settings/ChangePasswordForm";
import { USER_SETTINGS } from "../../constants/UserSettings";
import "./index.scss";

const ReactSwal = withReactContent(Swal);

const Settings = props => {
  React.useEffect(() => {
    props.getUserInfo();
  }, []);

  // const onChangeAvatar = () => {
  //   ReactSwal.fire({
  //     title: "Upload Profile Photo",
  //     text: "Please change the name of type",
  //     confirmButtonText: "CLOSE",
  //     cancelButtonText: "CLOSE",
  //     allowOutsideClick: true,
  //     allowEscapeKey: true,
  //     allowEnterKey: false,
  //     showCancelButton: true,
  //     html: (
  //       <AvatarUploader
  //         user={props.user}
  //         cognitoUser={props.cognitoUser}
  //         getCurrentCognitoUser={props.getCurrentCognitoUser}
  //         Auth={props.Auth}
  //       />
  //     )
  //   })
  //   .then(result => {
  //     if (result.value) {
        
  //     }
  //   });
  // }

  // const onSaveProfile = () => {
  //   props.getCurrentCognitoUser();
  // }

  const onChangePassword = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <ChangePasswordForm
          onClose={ReactSwal.clickCancel}
          onConfirm={ReactSwal.clickConfirm}
          Auth={props.Auth}
          cognitoUser={props.cognitoUser}
        />
      )
    })
    .then(result => {
      if (result.value) {
        
      }
    });
  }

  /**
   * Change the notification settings for the user
   * Options are stored in the form:
   *  appOptions: { pushEnabled: true }
   *  extensionOptions: { pushEnabled: false }
   * 
   * @param {String} settingName 
   * @param {BOOL} value 
   */
  const onToggleNotificationSettings = async (settingName, value) => {

    let attributeName = "";

    switch (settingName) {
      case USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED:
        attributeName = USER_SETTINGS.APP_OPTIONS.ATTRIBUTE;
        break;
      case USER_SETTINGS.EXTENSION_OPTIONS.PUSH_ENABLED:
        attributeName = USER_SETTINGS.EXTENSION_OPTIONS.ATTRIBUTE;
        break;
    
      default:
        break;
    }

    if (attributeName) {
      const currentOptions = _.get(props.userInfo, attributeName, { pushEnabled: true });
      currentOptions.pushEnabled = !value;
  
      props.changeUserAttribute({ name: attributeName, value: currentOptions, authAttribute: false });
    }
  }

  const onChangeDefaultFilter = (key, value) => {
    if (value) {
      props.changeUserAttribute({
        name: 'searchOptions',
        value: {
          ..._.get(props.userInfo, 'searchOptions', {}),
          [key]:value
        },
        authAttribute: false
      });
    } else {
      const newSettings = _.get(props.userInfo, 'searchOptions', {});
      delete newSettings[key];

      props.changeUserAttribute({
        name: 'searchOptions',
        value: newSettings,
        authAttribute: false
      });
    }
  }

  const { name, email } = props.cognitoUser.attributes;

  return (
    <div className="settings-container">
      <div className="profile-sidebar">
        <div className="profile-edit">
          <h3>Profile</h3>
          {/* <FontAwesomeIcon icon={faEdit} /> */}
        </div>
        <AvatarUploader
          user={props.user}
          cognitoUser={props.cognitoUser}
          getCurrentCognitoUser={props.getCurrentCognitoUser}
          Auth={props.Auth}
        />
        <div className="role-box">
          <span className="name">{name}</span>
          <span className="role"><i>Team Administrator</i></span>
        </div>

        <div className="personal-details">
          <div className="personal-info">
            <span className="key">COMPANY</span>
            <span className="value">{_.get(props.user, 'companyName', '')}</span>
          </div>
          
        </div>
        {/* <ButtonToolbar>
          <Button variant="outline-danger" size="sm" onClick={this.onSaveProfile}>SAVE PROFILE</Button>
        </ButtonToolbar> */}
      </div>
      <div className="settings-content">
        <h3 className="mb-4 mt-4">Settings</h3>
        <Row className="full-width">
          <div className="security-section flex items-start">
            <Card bg="light" className="full-width mr-4">
              <Card.Header>Security</Card.Header>
              <Card.Body>
                <SettingsItem
                  title="USER EMAIL"
                  value={email}
                  buttonTitle="CHANGE"
                />
                <SettingsItem
                  title="PASSWORD"
                  value="●●●●●●●●●●●"
                  buttonTitle="CHANGE"
                  onClick={onChangePassword}
                />
              </Card.Body>
            </Card>
            {/* Off until feature is ready */}
            <Card bg="light" className="full-width">
              <Card.Header>Notification Settings</Card.Header>
              <Card.Body>
                <div className="flex justify-between items-center py-4">
                  <div>Web Notification</div>
                  <ToggleButton
                    value={_.get(props.userInfo, USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED, true)}
                    thumbStyle={{ borderRadius: 2 }}
                    trackStyle={{ borderRadius: 2 }}
                    colors={{
                      active: {
                        base: 'rgb(76,210,126)',
                      } 
                    }}
                    onToggle={value => onToggleNotificationSettings(USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED, value)}
                  />
                </div>
                <div className="flex justify-between items-center py-2">
                  <div>Extension Notification</div>
                  <ToggleButton
                    value={_.get(props.userInfo, USER_SETTINGS.EXTENSION_OPTIONS.PUSH_ENABLED, true)}
                    thumbStyle={{ borderRadius: 2 }}
                    trackStyle={{ borderRadius: 2 }}
                    colors={{
                      active: {
                        base: 'rgb(76,210,126)',
                      } 
                    }}
                    onToggle={value => onToggleNotificationSettings(USER_SETTINGS.EXTENSION_OPTIONS.PUSH_ENABLED, value)}
                  />
                </div>
              </Card.Body>
            </Card>
          </div>
        </Row>
        {/* <Row className="full-width">
          <Col className="d-flex">
            <IntegrationCard
              title="CC AddOn for Hubspot"
              description="Create collaborative repositories for your campaigns into the biggest inbound platform"
              buttonTitle="ADMINISTRATE"
            />
            <IntegrationCard
              title="CC AddOn for Hubspot"
              description="Create collaborative repositories for your campaigns into the biggest inbound platform"
              buttonTitle="ADMINISTRATE"
            />
            <AddItem />
          </Col>
        </Row> */}
        <Row className="full-width">
          <div className="selector-section">
            <Card bg="light" className="full-width full-height">
              <Card.Header>Search Filters</Card.Header>
              <Card.Body>
                <SettingsMultiSelector
                  title="Tags"
                  options={_.get(props.settings, 'contentTags', [])}
                  selected={_.get(props.userInfo, 'searchOptions.tags', [])}
                  onChange={values => onChangeDefaultFilter('tags', values)}
                />
                {_.get(props.settings, 'appOptions.enableProducts', false) &&
                  <SettingsMultiSelector
                    title="Products"
                    options={_.get(props.settings, 'contentProducts', [])}
                    selected={_.get(props.userInfo, 'searchOptions.products', [])}
                    onChange={values => onChangeDefaultFilter('products', values)}
                  />
                }
                {_.get(props.settings, 'appOptions.enableIndustries', false) &&
                  <SettingsMultiSelector
                    title="Industries"
                    options={_.get(props.settings, 'contentIndustries', [])}
                    selected={_.get(props.userInfo, 'searchOptions.industries', [])}
                    onChange={values => onChangeDefaultFilter('industries', values)}
                  />
                }
                {_.get(props.settings, 'appOptions.enableRegions', false) &&
                  <SettingsMultiSelector
                    title="Regions"
                    options={_.get(props.settings, 'contentRegions', [])}
                    selected={_.get(props.userInfo, 'searchOptions.regions', [])}
                    onChange={values => onChangeDefaultFilter('regions', values)}
                  />
                }
              </Card.Body>
            </Card>
          </div>
        </Row>
      </div>
      {/* <div className="recent-history-wrapper">
        <h3>Recent activity</h3>
        <HistoryCard activities={props.activities} />
      </div> */}
    </div>
  );
}

const mapStateToProps = state => ({
  user: state.auth.tenant || {},
  Auth: state.auth.Auth,
  cognitoUser: state.auth.cognitoUser,
  activities: state.activity.activities,
  settings: state.settings,
  userInfo: state.settings.userInfo
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  getCurrentCognitoUser,
  changeUserAttribute,
  getUserInfo
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));
